import React from "react";
import TitleStripe from "../../common/TitleStripe";
import { Alert, Button } from "flowbite-react";
import TitleStripe2 from "../../common/TitleStripe2";

const CRLV = ({ data }) => {
  const handleDownloadPdf = () => {
    const base64 = data?.crlv?.pdfFile?.fileBase64;
    if (!base64) return;

    const byteCharacters = atob(base64);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "crlv.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <TitleStripe2>📝 CRLV</TitleStripe2>
      {data?.crlv?.statusRetorno == 1 ? (
        <>
          {data?.crlv?.imageFile?.fileBase64 ? (
            <img
              className="mt-5 mx-auto w-full max-w-xl"
              src={`data:image/jpeg;base64,${data?.crlv?.imageFile?.fileBase64}`}
              alt="CRLV"
            />
          ) : (
            <Alert withBorderAccent color="gray" className="mt-5">
              Nenhuma visualização disponível!
            </Alert>
          )}

          {data?.crlv?.pdfFile?.fileBase64 && (
            <div className="mt-5 text-center flex justify-center">
              <Button className="bg-primary" onClick={handleDownloadPdf}>
                Baixar CRLV em PDF
              </Button>
            </div>
          )}
        </>
      ) : (
        <Alert withBorderAccent color="gray" className="mt-5">
          Consulta Indisponível no momento
        </Alert>
      )}
    </div>
  );
};

export default CRLV;
